<app-generic-autocomplete
  [formGroup]="formGroup"
  [autocompleteControlName]="'user'"

  [filterPermission]="'USER_VIEW'"
  [filterFunction]="filterUsers.bind(this)"
  [displayField]="'userDisplayName'"
  [selected]="selected"

  [inactive]="inactive"
  [inactiveMessage]="inactiveMessage"
  [noMatchFoundMessage]="noMatchFoundMessage"

  [label]="label"
  [errorRequiredMessage]="errorRequiredMessage"

  [required]="required"
  [autocompleteDisabled]="autocompleteDisabled"
  [appearance]="appearance"
  [id]="id"
  (valueChanged)="onUserSelected($event)"
></app-generic-autocomplete>
